import React from 'react';

import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import classNames from "classnames";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetHeader} from "./entity-scores-widget.header";
import {EntityScoresWidgetController} from "../entity-scores-widget.controller";
import {EntityScoresWidgetContent} from "./entity-scores-widget.content";
import styles from "../styles/entity-scores-widget.module.scss";
import {PromotionBanner} from "../../../core/components/promotion-banner/promotion-banner";
import {EntityScoresWidgetState} from "../models/entity-scores-widget.state";
import {EntityScoresWidgetFiltersHeader} from "./entity-scores-widget.filters-header";

export class EntityScoresWidgetProps extends BaseProps {
  state: EntityScoresWidgetState;
}

export const EntityScoresWidget = ({
                                     controller,
                                     filterName,
                                     onFilterChange,
                                     isSideBar,
                                     context,
                                     shouldRenderHeaderFilterTabs
                                   }: EntityScoresWidgetProps) => {
  const {device, state} = controller;
  const {isCompetitorPage, entityContext, isWidget} = state;
  const {isSmallView} = device;
  const headerProps = {
    controller,
    filterName,
  }

  const contentProps = {
    controller,
    onFilterChange,
    context,
    isSideBar
  }

  const promotionBannerProps = {
    competitorId: isCompetitorPage ? entityContext?.id : null,
    competitionId: !isCompetitorPage ? entityContext?.id : null,
    className: classNames({[styles.promotion_banner]: isCompetitorPage})
  }

  return (
    <div className={classNames(styles.container, {
      [styles.small_view]: isSmallView,
      [styles.is_widget]: isWidget,
      [styles.side_bar]: isSideBar
    })}>
      {
        shouldRenderHeaderFilterTabs ? <EntityScoresWidgetHeader {...headerProps}/> : null
      }
      <EntityScoresWidgetFiltersHeader controller={controller}/>
      <PromotionBanner {...promotionBannerProps}/>
      <EntityScoresWidgetContent {...contentProps}/>
    </div>
  )
}

const settings: ComposeSettings = {
  component: EntityScoresWidget,
  propsType: EntityScoresWidgetProps,
  controllerType: EntityScoresWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,
  observe: true,
}

export default Compose(settings);

